import React, { Fragment } from 'react';
import axios from 'axios'
import Qs from 'qs';

import Swal from 'sweetalert2'
import { clearSession } from 'session';

export default class InfoModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = { items: null, info: null, lang_version: props.lang_version, option: props.option, title: "" }
    }

    static getDerivedStateFromProps(props, state) {
        let new_state = {};
        let flag = false;
        if (props.lang_version !== state.lang_version) {
            new_state.lang_version = props.lang_version;
            flag = true;
        }

        if (props.option !== state.option) {
            new_state.option = props.option;
            flag = true;
        }

        if (flag) {
            return new_state;
        }
        return null;
    }

    componentDidMount() {
        let session = window.localStorage;
        let url;
        if (this.state.option === "law" || this.state.option === "regulation") {
            url = session.ch_action_url + "/action/get_home_rules_info";
        }
        else {
            url = session.ch_action_url + "/action/get_home_donation_info";
        }
        axios.post(url, Qs.stringify({
            token: session.ch_token
        })).then(res => {
            if (res.data.status === -1) {
                clearSession();
            }
            else if (res.data.status === 0) {
                Swal.fire(
                    'Operation Failed!',
                    res.data.info,
                    'error');
            }
            else {
                let item = res.data.data;
                let info = "";
                let title = "";
                if (this.state.option === "law") {
                    info = item.laws;
                    title = "Huaxia Chorus By-Laws";
                    if (this.state.lang_version === "ch") {
                        title = "法律法规";
                    }
                }
                if (this.state.option === "regulation" && this.state.lang_version === "en") {
                    info = item.regulations_en;
                    title = "Huaxia Chorus Regulations";

                }
                if (this.state.option === "regulation" && this.state.lang_version === "ch") {
                    info = item.regulations_ch;
                    title = "合唱团规则";

                }
                if (this.state.option === "donation_introduction" && this.state.lang_version === "en") {
                    info = item.introduction_en;
                    title = "Donation Introduction";

                }
                if (this.state.option === "donation_introduction" && this.state.lang_version === "ch") {
                    info = item.introduction_ch;
                    title = "捐款说明";

                }
                if (this.state.option === "donation_letter" && this.state.lang_version === "en") {
                    info = item.letter_en;
                    title = "A Letter To Donators";
                }
                if (this.state.option === "donation_letter" && this.state.lang_version === "ch") {
                    info = item.letter_ch;
                    title = "致捐赠者的一封信";

                }
                this.setState({ item: item, info: info, title: title });
            }
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if ((this.state.option === "donation_introduction" && (prevState.option === "law" || prevState.option === "regulation")) || (this.state.option === "donation_letter" && (prevState.option === "law" || prevState.option === "regulation"))
            || (this.state.option === "law" && (prevState.option === "donation_introduction" || prevState.option === "donation_letter")) || (this.state.option === "regulation" && (prevState.option === "donation_introduction" || prevState.option === "donation_letter"))) {
            let session = window.localStorage;
            let url;
            if (this.state.option === "law" || this.state.option === "regulation") {
                url = session.ch_action_url + "/action/get_home_rules_info";
            }
            else {
                url = session.ch_action_url + "/action/get_home_donation_info";
            }
            axios.post(url, Qs.stringify({
                token: session.ch_token
            })).then(res => {
                if (res.data.status === -1) {
                    clearSession();
                }
                else if (res.data.status === 0) {
                    Swal.fire(
                        'Operation Failed!',
                        res.data.info,
                        'error');
                }
                else {
                    let item = res.data.data;
                    let info = "";
                    let title = "";

                    if (this.state.option === "law") {
                        info = item.laws;
                        title = "Huaxia Chorus By-Laws";
                        if (this.state.lang_version === "ch") {
                            title = "法律法规";
                        }
                    }
                    if (this.state.option === "regulation" && this.state.lang_version === "en") {
                        info = item.regulation_en;
                        title = "Huaxia Chorus Regulations";

                    }
                    if (this.state.option === "regulation" && this.state.lang_version === "ch") {
                        info = item.regulation_ch;
                        title = "合唱团规则";

                    }
                    if (this.state.option === "donation_introduction" && this.state.lang_version === "en") {
                        info = item.introduction_en;
                        title = "Donation Introduction";

                    }
                    if (this.state.option === "donation_introduction" && this.state.lang_version === "ch") {
                        info = item.introduction_en;
                        title = "捐款说明";

                    }
                    if (this.state.option === "donation_letter" && this.state.lang_version === "en") {
                        info = item.letter_en;
                        title = "A Letter To Donators";
                    }
                    if (this.state.option === "donation_letter" && this.state.lang_version === "ch") {
                        info = item.letter_ch;
                        title = "致捐赠者的一封信";

                    }
                    this.setState({ item: item, info: info, title: title });
                }
            });
        }
        else if (this.state.lang_version !== prevState.lang_version || this.state.option !== prevState.option) {
            let item = this.state.item;
            let info = "";
            let title = "";
            if (this.state.option === "law") {
                info = item.laws;
                title = "Huaxia Chorus By-Laws";
                if (this.state.lang_version === "ch") {
                    title = "法律法规";
                }
            }
            if (this.state.option === "regulation" && this.state.lang_version === "en") {
                info = item.regulations_en;
                title = "Huaxia Chorus Regulations";

            }
            if (this.state.option === "regulation" && this.state.lang_version === "ch") {
                info = item.regulations_ch;
                title = "合唱团规则";

            }
            if (this.state.option === "donation_introduction" && this.state.lang_version === "en") {
                info = item.introduction_en;
                title = "Donation Introduction";

            }
            if (this.state.option === "donation_introduction" && this.state.lang_version === "ch") {
                info = item.introduction_ch;
                title = "捐款说明";

            }
            if (this.state.option === "donation_letter" && this.state.lang_version === "en") {
                info = item.letter_en;
                title = "A Letter To Donators";
            }
            if (this.state.option === "donation_letter" && this.state.lang_version === "ch") {
                info = item.letter_ch;
                title = "致捐赠者的一封信";

            }
            this.setState({ info: info, title: title });
        }
    }

    render() {
        return (
            <Fragment>
                <div className="text-center p-3" style={{borderBottom:"1px #e6e7ef solid"}}>
                    <b>{this.state.title}</b>
                </div>
                <div className="p-4 font-size-lg text-black" dangerouslySetInnerHTML={{ __html: this.state.info }} />
            </Fragment>
        );
    }
}